export default __webpack_public_path__ + "static/media/database.88820a9c.bin";